import { render, staticRenderFns } from "./LeaveDetails.vue?vue&type=template&id=23edd61b"
import script from "./LeaveDetails.vue?vue&type=script&lang=js"
export * from "./LeaveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports